import GenericModel from './generic-model'

export default class UsersDB extends GenericModel {
  constructor() {
    super('users')
  }

  // Here you can extend UserDB with custom methods
}
